import { FacilitiesActions } from './actionNames'
import initialState from './initialState'

export default function(
  store: IFacilitiesStore = initialState,
  action: any,
): IFacilitiesStore {
  switch (action.type) {
    case FacilitiesActions.FacilitiesAccepted:
      return {
        ...store,
        facilities: action.payload,
      }
    case FacilitiesActions.FacilitiesObjectAccepted:
      return {
        ...store,
        facilitiesObject: action.payload,
      }
  }
  return store
}

export interface IFacilities {
  category: string
  created_at: string
  deleted: string
  id: string
  name: string
  updated_at: string
}

export interface IFacilitiesStore {
  facilities: IFacilities[]
  facilitiesObject: { [key: string]: string[] }
}
